// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#picture-in-picture {
  width: 100%;
  height: 300px;
}
.hidden {
  display: none;
}
.refreshIcon {
  position: fixed;
  bottom: 20px; /* Adjust as needed */
  left: 18%;
  bottom: 5%;
  transform: translateX(-50%);
  cursor: pointer;
}
.css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-lastButton,
.css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-middleButton {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  margin-left: -3px !important;
}
#caller {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
#caller video {
  height: 600px !important;
  width: 90%;
}

#me video {
  width: 100%;
}
#me {
  position: absolute;
  width: 25%;
  bottom: 2%;
  left: 5%;
}
#hangup {
  position: absolute;
  bottom: 5%;
  left: 5%;
}
.noRequests {
  text-align: center;
}
.tester2 {
  width: 30px !important;
  position: absolute !important;
  height: 30px !important;
  right: -4px !important;
  bottom: 72px !important;
  background: white !important;
}
.tester1 {
  z-index: 111111111111111 !important;
  width: 30px !important;
  position: absolute !important;
  height: 30px !important;
  right: -4px !important;
  bottom: 72px !important;
  background: white !important;
}
.tester {
  background: white !important;
  z-index: 111111111111111 !important;
  width: 30px !important;
  position: absolute !important;
  height: 30px !important;
  right: 20px !important;
  bottom: 20px !important;
}
.modalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999999;
}
.buttonContainer {
  display: flex;
  gap: 20px;
}
.acceptButton,
.declineButton {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.declineButton {
  background-color: #ff0000;
}

.acceptButton:hover,
.declineButton:hover {
  background-color: #0056b3;
}

.containerIn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}
.circleContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  bottom: 0px;
}
.colorIcon {
  color: "#ff6500" !important;
}
.colorIcon2 .css-i4bv87-MuiSvgIcon-root {
  color: white !important;
  background: #5599ff !important;
  width: 50px !important;
  height: 50px !important;
  border-radius: 10px !important;
  font-size: 10px !important;
  padding: 10px !important;
}
.avatarSize {
  width: 160px !important;
  height: 160px !important;
  font-size: 4rem !important;
}
.imageContainerChat {
  background: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);
}
.addIcon {
  position: absolute;
  z-index: 1111;
  top: 77px;
  left: 377px;
}
.custom-message {
  margin-left: auto;
}
.circleImage {
  width: 185px;
  height: 185px;
  border-radius: 50%;
  object-fit: cover;
}
.incoming .message-text {
  text-align: left !important;
}
.custom-message-time .custom-outgoing-message {
  text-align: right !important;
}
.ringingText {
  margin-top: 25px !important;
  font-size: 13px !important;
  color: #aaaaaa !important;
  font-weight: 600 !important;
}
.ringintextremove {
  position: absolute;
  bottom: -120%;
  font-size: 13px !important;
  color: #aaaaaa !important;
  font-weight: 600 !important;
}
.switchRemote {
  object-fit: cover !important;
  position: absolute !important;
  top: 0 !important;
  left: 3% !important; /* Adjust the left positioning based on your requirements */
  margin-top: 38vh !important; /* Use margin-top instead of top for relative positioning */
  border-radius: 10px !important;
  width: 25% !important;
  height: 30vh !important;
}

.switchLocal {
  object-fit: cover !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  border-radius: 10px !important;
  width: 100% !important;
  height: 70vh !important;
}

.containerChat {
  /* height: 80vh; */
  display: flex;
  justify-content: center;
}
.containerLogin {
  height: 93vh;
  display: flex;
  justify-content: center;
}
.bottom-left {
  border: 1px solid #fafbfe;
  background-color: white;
  padding: 10px 20px;
  border-radius: 40px;
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 20px;
  height: 55px;
  width: 55px;
  left: 150px;
}
.top-image img {
  width: 90% !important;
  border-radius: 10px !important;
}

/* Add this CSS to your component's CSS or a separate CSS file */

.callContainer {
  box-shadow: 1px 1px 1px 1px #d8d7d741;
  border: 2px solid #d8d7d741;
  margin-top: 2px;
  object-fit: cover;
  width: inherit;
  height: inherit;
}
.callButtons {
  display: flex;
  gap: 10px;
  /* background-color: #fdfdfd; */
  padding: 10px;
}

.control-buttons {
  margin: 4px 5px;
  border-radius: 50% !important; /* Make the button circular */
  width: 40px !important; /* Adjust the width as needed */
  height: 40px !important; /* Adjust the height as needed */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.control-buttons:hover {
  background-color: #4b4a4a; /* Slightly darker on hover */
  transform: scale(1.1); /* Slight enlargement on hover */
}

.control-buttons:active {
  background-color: #bdbdbd; /* Darker color when clicked */
  transform: scale(0.9); /* Slight shrink on click */
}

.button-light {
}

.control-buttonsRed {
  /* margin: 0px 5px; */
  background-color: #f85252 !important; /* Set the background color to light grey */
  border-radius: 20px !important; /* Make the button circular */
  width: 40px !important; /* Adjust the width as needed */
  height: 40px !important; /* Adjust the height as needed */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.control-buttonsRed:hover {
  background-color: #d32f2f; /* Darker red on hover */
  transform: scale(1.1);
}

.control-buttonsRed:active {
  background-color: #b71c1c; /* Even darker red when clicked */
  transform: scale(0.9);
}

.control-buttonsRec {
  background-color: #f7f7f7 !important; /* Set the background color to light grey */
  border-radius: 20px !important; /* Make the button circular */
  width: 70px !important; /* Adjust the width as needed */
  height: 40px !important; /* Adjust the height as needed */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.bottom-middle {
  background-color: none;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 20px;
  align-items: flex-end;
  left: 58%;
  z-index: 11;
}

.formattedTime {
  color: white;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
  align-self: center;
  background-color: #b3b3b3;
  border-radius: 14px;
  line-height: 0%;
  padding: 2px 4px;
}

.plexar_font {
  color: #59f !important;
}
.text-wrap {
  white-space: normal !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}
.sub_heading {
  color: gray;
  font-size: 90%;
}
.sub_heading2 {
  color: gray;
  font-size: 60%;
}
.control-button {
  margin: 0 10px;
  padding: 10px;
}

.bottom-right {
  border: 1px solid #fafbfe;
  background-color: white;
  padding: 10px 20px;
  border-radius: 41px;
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 20px;
  right: 100px;
}

.recording-button {
  padding: 10px;
}

.sideNav {
  display: flex;
  flex-direction: column;
  border: 1px solid #ff6500;
  border-radius: 10px;
  background-color: #ffffff;
  margin-right: 5px;
}

.message-screen {
  /* display: grid;
  grid-template-columns: 30% 69%; */
  /* height: 90vh; */
  border-radius: 10px;
  padding: 16px;
  margin-left: 0 !important;
  margin-right: 0 !important;

  /* gap: 16px; */
}

/* @media (min-width: 1024px) {
  .message-screen {
    display: grid;
    grid-template-columns: 30% 69%;
  }
} */

@media (max-width: 991.9px) {
  .rightDiv {
    margin-top: 16px;
  }

  .noRequests {
    margin-top: 10px !important;
    margin-bottom: 17px !important;
  }

  .welcome-to {
    font-size: 32px !important;
  }
}

@media (max-width: 500px) {
  .add-frn {
    width: 80px !important;
  }

  .mng-btn {
    width: 120px !important;
  }

  .msg-name {
    display: none !important;
  }
}

@media (min-width: 767.9px) {
  .message-screen {
    height: 90vh;
  }

  .chat-header {
    height: 60px;
  }
}

@media (max-width: 767.9px) {
  .avt-sec {
    padding-left: 16px !important;
  }

  .chat-header {
    height: 60px;
  }

  .chatheader-info {
    display: none !important;
  }

  .message-input {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    background: white;
    .colorIcon2 {
      svg {
        height: 35px !important;
        width: 35px !important;
      }
    }

    input {
      padding-right: 0 !important;
    }

    .msg-type-area {
      padding: 0 !important;
      margin-right: 5px !important;
      display: flex;
      justify-content: space-between;
    }

    .message-input-icons {
      right: 70px !important;
    }

    .message-input-icons :first-child {
      padding-right: 0 !important;
    }

    .message-input-icons :last-child {
      padding-left: 0 !important;
    }
  }
}

.buzzcomScreen {
  overflow-y: auto;
}
.buzzcomScreen::-webkit-scrollbar {
  display: none;
}

.message-screen::-webkit-scrollbar {
  display: none; /* Hides the scrollbar in WebKit browsers */
}

.message-sidebar {
  overflow-y: auto;
  padding: 10px;
}

.message-sidebar::-webkit-scrollbar {
  display: none; /* Hides the scrollbar in WebKit browsers */
}

.message {
  cursor: pointer;
  padding: 10px;
  align-items: center;
}

.messageEnd {
  display: flex;
  cursor: pointer;
  padding: 10px;

  align-items: center;
}
.selected {
  background-color: #eff4f7 !important; /* Highlight selected chat */
  height: auto !important;
  width: auto !important;
}
.color {
  color: red;
}
.message img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.message-info {
  text-align: left;
  margin-left: 10px;
  line-height: 4px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  flex: 1 1;
  padding-top: 12px;
  font-size: 20px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.chatHeader {
  width: 964px;
  height: 60px;
  background-color: #ff6500;
}

.chatheader-info {
  color: white;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 18.75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2;
}
/* CSS for status indicators */
.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-left: 5px;
}

.online {
  background: green;
}

.offline {
  background: grey;
}

.away {
  background: yellow;
}

.chat-sidebar {
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100%;
}
.borders ::-webkit-scrollbar-thumb {
  background-color: grey !important;
}

.borders .css-78trlr-MuiButtonBase-root-MuiIconButton-root {
  border-radius: 0px !important;
  /* position: static !important;; */
}
.borders .css-8je8zh-MuiTouchRipple-root {
  border-right: 0px !important;
}

.dropdown-menu {
  width: 5px;
  overflow: hidden;
}

.iconColor {
  color: white !important;
}
.chatText {
  border: 1px solid #ccc;
  width: 100%;
  background-color: white;
}

.chat-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  border-radius: 10px 10px 0 0;
  background-color: #ff6500;
  padding: 0px 12px;
  padding-left: 20px;
}

.message-list {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow: "hidden";
  /* margin-top: 10px; */
  display: flex;
  flex-direction: column;
  border: none;
  padding-top: 15px;
}

.message-input {
  flex: 0 0 auto;
  display: "flex";
  align-items: "center";
}
.bg-warning {
  background-color: #ffc107 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

.text-white {
  color: #fff !important;
}

img.rounded-circle {
  object-fit: cover;
}

.message {
  padding: 5px;

  /* max-width: 70%; */
}
.micClr .css-i4bv87-MuiSvgIcon-root {
  color: #f85252 !important;
}
.closeIc {
  position: absolute;
  right: 9%;
}
.wide {
  background: rgb(247, 247, 247);
  border-radius: 10px;
  padding: 10px;
  margin: 15px;
  flex: 1 1;
}

.subHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-block: 10px;
  /* margin: 1px; */
  border-bottom: 1px solid #dfdfdf;
}

.Header1 {
  margin-left: 8px;
}

.layout-contact-messages {
  /* display: grid;
  grid-template-columns: 4% 95%; */
  margin-top: 95px;
}

.buzzSideNavItem {
  width: 100%;
  height: 30px;
  border: none;
  justify-content: center;
  align-items: center;
}

.leftDiv {
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  color: #d0d0d0;
  margin-bottom: 0px;
  font-size: 10px; /* Adjust the margin as needed */
  height: 100%;
  overflow: hidden;

  /* overflow-x: hidden; */
}

.leftDiv::-webkit-scrollbar {
  display: none; /* Hides the scrollbar in WebKit browsers */
}

.rightDiv {
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  margin-bottom: 0px;
  font-size: 10px; /* Adjust the margin as needed */
  overflow-y: auto;
  overflow: hidden;
  height: 100%;
}
.css-106c1u2-MuiBadge-badge {
  background-color: #5599ff !important;
}
.message-time {
  position: relative;
  top: -35px;
  text-align: left;
  margin-bottom: 0px;
  margin-left: 15px;
  color: #d0d0d0;
  font-size: 10px; /* Adjust the mcustomargin as needed */
}
.custom-message-time {
  position: relative;
  top: 10px;
  text-align: right;
  margin-bottom: 0px;
  margin-right: 30px;
  color: #d0d0d0;
  font-size: 10px; /* Adjust the margin as needed */
}

.custom-outgoing-message {
  display: flex;
  justify-content: flex-end; /* Push the messages to the right side */
  color: white !important;
}
.EmojiPickerReact {
  position: absolute !important;
  top: -460px;
  right: -50px;
}
.custom-message-text p,
.message-text p {
  top: 4px !important;
  position: relative;
}

.custom-message-text {
  line-height: 10px !important;

  padding: 8px;
  margin-top: 10px;
  font-size: 14px;
  border-radius: 8px;
  background-color: #ff6500; /* Background color for outgoing messages */
  margin-left: 10px; /* Adjust the margin between the time and the message */
}

.message-text {
  padding: 8px;
  border-radius: 8px;
  font-size: 14px;
  display: inline-block;
  background-color: #f2f2f2; /* Match the background color of incoming messages */
}

.incoming1 {
  align-self: flex-start;
}
.message1 {
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  /* max-width: 70%; */
}

.incoming {
  /* background-color: #e0e0e0; */
  position: relative;
  top: -45px;
  align-self: flex-start;
}

.outgoing {
  /* background-color: #007bff; */
  color: #fff;
  align-self: flex-end;
}

.username {
  font-weight: bold;
}

.fixed-header {
  background-color: #5599ff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  z-index: 111;
}

.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked,
.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate {
  color: #f5bf00 !important;
}
.incDiv {
  height: 58px !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 5px !important;
}
.incrementButton {
  padding: 0px 5px !important;
  min-width: 16px !important;
  height: 20px !important;
  border-radius: 15px !important;
  color: #dcdcdc !important;
  border: 2px solid #dcdcdc !important;
  font-weight: 700 !important;
  margin: 0px 10px !important;
}
.css-1ps6pg7-MuiPaper-root {
  box-shadow: none !important;
}
.decrementButton {
  margin: 0px 10px !important;
  padding: 0px 5px !important;
  min-width: 16px !important;
  height: 20px !important;
  border-radius: 5px !important;
  color: #dcdcdc !important;
  border: 2px solid #dcdcdc !important;
  font-weight: 700 !important;
}

.chipMain {
  height: 45px !important;
  padding-left: 10px !important;
  border-radius: 10px !important;
}
.chipMain1 {
  height: 45px !important;
  padding-left: 10px !important;
  border-radius: 10px !important;
  border: 1px solid #f5bf00 !important;
}
.chipMainDelete1 {
  color: #f5bf00 !important;
  font-size: 16px !important;
  border: 1px solid;
  border-radius: 5px;
  top: -9px;
  position: relative;
  right: -2px;
}
.chipMainDelete {
  color: #f5bf00 !important;
  font-size: 16px !important;
  border: 1px solid;
  border-radius: 5px;
  top: -9px;
  position: relative;
  right: -7px;
}
.MuiChip-label {
  color: #8a8a8a;
}
.chipMain {
  background-color: #f9faff !important;
}
.chipMain1 {
  background-color: white !important;
}
.MuiDrawer-paper {
  border-right: 1px solid #f5bf00 !important;
  border-top: 1px solid #f5bf00 !important;
  border-top-right-radius: 10px !important;
}
.MuiButtonBase-root {
  box-shadow: none !important;
}
.subheader {
  /* background-color: white !important; */
  margin-top: 40px !important;
  height: 40px;
  border-bottom: 1px solid #e4e4e4 !important;
}

.logo {
  width: 33px;
  height: 33px;
}

.header-right {
  display: flex;
  align-items: center;
}
.MuiSelect-outlined {
  text-align: left;
  padding-left: 5% !important;
  padding-top: 9% !important;
}
.icon-button {
  margin-right: 10px;
}
.icon-button svg {
  /* margin-right: 10px; */
  width: 16px;
  height: 16px;
}

.icon {
  width: 33px;
  height: 33px;
}

.expert-icon {
  width: 26px;
  height: 26px;
}

.admin-text {
  display: flex;
  margin-right: 10px;
  font-size: 10px;
}

.sub-text {
  font-size: 12px; /* Adjust the font size as needed */
  margin: 0;
  font-weight: 500;
}

.profile-wrapper {
  display: flex;
  align-items: center;
}

.vertical-divider {
  width: 2px;
  height: 20px; /* Adjust the height as needed */
  background: #e0e0e0; /* Vertical divider color */
  /* margin-right: 10px;  */
  align-items: center;
  top: 8;
}

.profile-image {
  width: 30px;
  height: 30px;
  border-radius: 50%; /* Make it round */
}
.MuiFormControl-root,
.MuiOutlinedInput-root {
  background: white !important;
  height: 50px !important;
}
.horizontal-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 !important;
}

/* Style for each list item */
.horizontal-list-item {
  margin-right: 20px; /* Adjust the spacing as needed */
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
}
.horizontal-list-item a {
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  color: #a4a4a4;
  margin-left: 5px;
}
.MuiDrawer-root,
.MuiDrawer-paper {
  width: 40px !important;
}
.horizontal-list-item .horizontal-list-icon {
  height: 20px;
  width: 20px;
  color: #a4a4a4;
}

.horizontal-list-icon {
  margin-right: 5px; /* Adjust the spacing between icon and text */
}

/* Style for active list item */
.active {
  color: black !important ;
}
svg use {
  fill: #ff0000; /* Change the fill color to red (#FF0000) */
}
.icon {
  width: 20px;
  height: 20px;
  fill: #000; /* Default color */
  transition: fill 0.3s; /* Smooth transition for color change */
}

.icon-hover:hover {
  fill: #ff0000; /* New color on hover (e.g., red) */
}

/* Style for active icon */
.horizontal-list-icon.active {
  color: #f5bf00 !important; /* Change the icon color to yellow for active items */
}
.App {
  font-family: sans-serif;
}
.uploadButton {
  height: 25px !important;
  border-radius: 6px !important;
  width: 70px !important;
  font-size: 12px !important;
}
.createButton {
  height: 40px;
  border-radius: 8px !important;
  width: 160px;
  font-size: 14px !important;
}
.listButton {
  height: 30px !important;
  width: 70px !important;
  font-size: 12px !important;
}
table > thead > tr > th {
  font-size: 14px;
  font-weight: 400;
  color: #6b6b6b !important;
}
table > tbody > tr > td {
  vertical-align: middle !important;
  font-size: 14px;
  padding: 0px !important;
  font-weight: 400;
  color: #a4a4a4 !important;
}
table > tbody > tr > td input {
  border: none;
  background: #f4f5fb;
  padding: 10px;
  width: 100%;
}

.reddit
  .css-1m4j16o-MuiFormControl-root-MuiTextField-root
  .MuiFilledInput-root {
  background-color: transparent !important;
}
.switchPlace {
  position: absolute !important;
  left: 74%;
  top: 21px;
  z-index: 1111 !important;
}
.switchPlace1 {
  position: absolute !important;
  left: 74%;
  top: -50px;
  z-index: 1111 !important;
}

.css-1fqi8hc-MuiButtonBase-root-MuiListItemButton-root:hover {
  background-color: #f5bf00 !important;
}
.checks {
  text-align: left;
}
/* .MuiOutlinedInput-notchedOutline {
  border-width: 1px !important;
  border-color: #ccc;
} */

.checks .MuiTypography-root {
  color: "#A4A4A4" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #f5bf00 !important;
}
.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
  color: #8a8a8a !important;
}
.customiseSelect {
  position: absolute !important;
  top: -11px !important;

  font-size: 12px !important;
}
.drawers .MuiDrawer-paperAnchorLeft {
  margin-top: 80px !important;
}
.fixed-header {
  background-color: #333;
  color: white;

  padding-left: 5px;
  padding-right: 25px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
}
.custom-container {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  align-items: center;
}

.custom-image-container {
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  width: 80px;
  height: 80px;
}
.MuiSwitch-switchBase {
  color: #f5bf00 !important;
}
.error-message {
  text-align: left;
  font-size: 13px;
  color: red;
}
.custom-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
}
.error .MuiInputBase-root {
  border-color: red !important ;
}
.iconicMain:hover {
  background-color: #f5bf00 !important;
}
.iconicMain:hover .iconic .MuiSvgIcon-root {
  color: white !important;
}
.iconic .MuiSvgIcon-root {
  height: 15px !important;
  width: 15px !important;
}
.custom-text-container {
  flex: 1 1;
  text-align: left;
}

.custom-heading {
  font-size: 24px;
  font-weight: 600;
}

.custom-url {
  font-size: 14px;
  font-weight: 500;

  color: #6c6c6c; /* Your primary color */
}

.custom-button {
  margin-left: 16px;
}

.subheader {
  background-color: #f4f4f4;
  padding: 5px;
  padding-right: 25px;
  margin-top: 70px; /* Adjust this margin to make space for the fixed header */
  width: 100%;
  position: fixed;
  z-index: 111;
}

#columnHeaders {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f0f0f0;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

/* Styling for the draggable columns */
.draggable-column {
  background-color: #fff;
  padding: 8px;
  border-right: 1px solid #ddd;
}

/* Styling for the last column */
.draggable-column:last-child {
  border-right: none;
}

/* Styling for the dragged column while dragging */
.dragging {
  background-color: #f0f0f0;
  transition: background-color 0.2s;
}

/* buzzcom.css */
.layout {
  min-height: 100vh;
}

.logo {
  width: 100px; /* Fixed width of container */
  height: 100px; /* Fixed height of container */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Hide overflow if the image doesn't perfectly fit */
  background-color: #f0f0f0; /* Optional: background color to visually see the box */
}

.logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover; /* Fill the container without stretching */
  object-position: center;
}

.signup-button {
  float: right;
}

.ant-layout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .signup-button {
    display: none; /* Hide on smaller screens if needed */
  }
}

.modal-backdrop,
div[role="dialog"],
.toast {
  z-index: 99999999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/customStyle.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY,EAAE,qBAAqB;EACnC,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,sCAAsC;EACtC,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB,EAAE,2DAA2D;EAChF,2BAA2B,EAAE,2DAA2D;EACxF,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,gEAAgE;;AAEhE;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,6BAA6B,EAAE,6BAA6B;EAC5D,sBAAsB,EAAE,+BAA+B;EACvD,uBAAuB,EAAE,gCAAgC;EACzD,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,qBAAqB,EAAE,gCAAgC;AACzD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;AACA;;AAEA;EACE,qBAAqB;EACrB,oCAAoC,EAAE,2CAA2C;EACjF,8BAA8B,EAAE,6BAA6B;EAC7D,sBAAsB,EAAE,+BAA+B;EACvD,uBAAuB,EAAE,gCAAgC;EACzD,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,qBAAqB;AACvB;;AAEA;EACE,oCAAoC,EAAE,2CAA2C;EACjF,8BAA8B,EAAE,6BAA6B;EAC7D,sBAAsB,EAAE,+BAA+B;EACvD,uBAAuB,EAAE,gCAAgC;EACzD,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;mCACiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB;MACE;QACE,uBAAuB;QACvB,sBAAsB;MACxB;IACF;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,qBAAqB;MACrB,4BAA4B;MAC5B,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;;EAEb,mBAAmB;AACrB;AACA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;;EAEZ,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,SAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;kCACgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAE,gCAAgC;EACjD,YAAY;EACZ,gBAAgB;;EAEhB,wBAAwB;AAC1B;;AAEA;EACE,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe,EAAE,gCAAgC;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAE,sCAAsC;AACzD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAE,gCAAgC;AACnD;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,wCAAwC;EACnE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;;EAE5B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB,EAAE,2CAA2C;EACtE,iBAAiB,EAAE,uDAAuD;AAC5E;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB,EAAE,oDAAoD;AACjF;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,mCAAmC;EACpD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY,EAAE,gCAAgC;EAC9C,mBAAmB,EAAE,2BAA2B;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,kBAAkB;AACxC;AACA;;EAEE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB,EAAE,iCAAiC;EACrD,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa,EAAE,2CAA2C;AAC5D;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,kBAAkB;EAC9B,qBAAqB,EAAE,uCAAuC;AAChE;;AAEA;EACE,aAAa,EAAE,mCAAmC;AACpD;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,qDAAqD;AAClF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;;;GAGG;;AAEH;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;;EAErB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,YAAY;;EAEZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAE,0DAA0D;EAC5E,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,6BAA6B;EAC3C,aAAa,EAAE,8BAA8B;EAC7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE,qDAAqD;EACvE,yBAAyB,EAAE,uDAAuD;AACpF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,0CAA0C;EAC7D,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa,EAAE,sCAAsC;EACvD;AACF;;AAEA;;;EAGE,4BAA4B;AAC9B","sourcesContent":["#picture-in-picture {\n  width: 100%;\n  height: 300px;\n}\n.hidden {\n  display: none;\n}\n.refreshIcon {\n  position: fixed;\n  bottom: 20px; /* Adjust as needed */\n  left: 18%;\n  bottom: 5%;\n  transform: translateX(-50%);\n  cursor: pointer;\n}\n.css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-lastButton,\n.css-edsu1d-MuiButtonGroup-root .MuiButtonGroup-middleButton {\n  border-top-left-radius: 5px !important;\n  border-bottom-left-radius: 5px !important;\n  margin-left: -3px !important;\n}\n#caller {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n#caller video {\n  height: 600px !important;\n  width: 90%;\n}\n\n#me video {\n  width: 100%;\n}\n#me {\n  position: absolute;\n  width: 25%;\n  bottom: 2%;\n  left: 5%;\n}\n#hangup {\n  position: absolute;\n  bottom: 5%;\n  left: 5%;\n}\n.noRequests {\n  text-align: center;\n}\n.tester2 {\n  width: 30px !important;\n  position: absolute !important;\n  height: 30px !important;\n  right: -4px !important;\n  bottom: 72px !important;\n  background: white !important;\n}\n.tester1 {\n  z-index: 111111111111111 !important;\n  width: 30px !important;\n  position: absolute !important;\n  height: 30px !important;\n  right: -4px !important;\n  bottom: 72px !important;\n  background: white !important;\n}\n.tester {\n  background: white !important;\n  z-index: 111111111111111 !important;\n  width: 30px !important;\n  position: absolute !important;\n  height: 30px !important;\n  right: 20px !important;\n  bottom: 20px !important;\n}\n.modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999999;\n}\n.buttonContainer {\n  display: flex;\n  gap: 20px;\n}\n.acceptButton,\n.declineButton {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.declineButton {\n  background-color: #ff0000;\n}\n\n.acceptButton:hover,\n.declineButton:hover {\n  background-color: #0056b3;\n}\n\n.containerIn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n}\n.circleContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  bottom: 0px;\n}\n.colorIcon {\n  color: \"#ff6500\" !important;\n}\n.colorIcon2 .css-i4bv87-MuiSvgIcon-root {\n  color: white !important;\n  background: #5599ff !important;\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 10px !important;\n  font-size: 10px !important;\n  padding: 10px !important;\n}\n.avatarSize {\n  width: 160px !important;\n  height: 160px !important;\n  font-size: 4rem !important;\n}\n.imageContainerChat {\n  background: white;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);\n}\n.addIcon {\n  position: absolute;\n  z-index: 1111;\n  top: 77px;\n  left: 377px;\n}\n.custom-message {\n  margin-left: auto;\n}\n.circleImage {\n  width: 185px;\n  height: 185px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.incoming .message-text {\n  text-align: left !important;\n}\n.custom-message-time .custom-outgoing-message {\n  text-align: right !important;\n}\n.ringingText {\n  margin-top: 25px !important;\n  font-size: 13px !important;\n  color: #aaaaaa !important;\n  font-weight: 600 !important;\n}\n.ringintextremove {\n  position: absolute;\n  bottom: -120%;\n  font-size: 13px !important;\n  color: #aaaaaa !important;\n  font-weight: 600 !important;\n}\n.switchRemote {\n  object-fit: cover !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 3% !important; /* Adjust the left positioning based on your requirements */\n  margin-top: 38vh !important; /* Use margin-top instead of top for relative positioning */\n  border-radius: 10px !important;\n  width: 25% !important;\n  height: 30vh !important;\n}\n\n.switchLocal {\n  object-fit: cover !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  border-radius: 10px !important;\n  width: 100% !important;\n  height: 70vh !important;\n}\n\n.containerChat {\n  /* height: 80vh; */\n  display: flex;\n  justify-content: center;\n}\n.containerLogin {\n  height: 93vh;\n  display: flex;\n  justify-content: center;\n}\n.bottom-left {\n  border: 1px solid #fafbfe;\n  background-color: white;\n  padding: 10px 20px;\n  border-radius: 40px;\n  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 20px;\n  height: 55px;\n  width: 55px;\n  left: 150px;\n}\n.top-image img {\n  width: 90% !important;\n  border-radius: 10px !important;\n}\n\n/* Add this CSS to your component's CSS or a separate CSS file */\n\n.callContainer {\n  box-shadow: 1px 1px 1px 1px #d8d7d741;\n  border: 2px solid #d8d7d741;\n  margin-top: 2px;\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n}\n.callButtons {\n  display: flex;\n  gap: 10px;\n  /* background-color: #fdfdfd; */\n  padding: 10px;\n}\n\n.control-buttons {\n  margin: 4px 5px;\n  border-radius: 50% !important; /* Make the button circular */\n  width: 40px !important; /* Adjust the width as needed */\n  height: 40px !important; /* Adjust the height as needed */\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.control-buttons:hover {\n  background-color: #4b4a4a; /* Slightly darker on hover */\n  transform: scale(1.1); /* Slight enlargement on hover */\n}\n\n.control-buttons:active {\n  background-color: #bdbdbd; /* Darker color when clicked */\n  transform: scale(0.9); /* Slight shrink on click */\n}\n\n.button-light {\n}\n\n.control-buttonsRed {\n  /* margin: 0px 5px; */\n  background-color: #f85252 !important; /* Set the background color to light grey */\n  border-radius: 20px !important; /* Make the button circular */\n  width: 40px !important; /* Adjust the width as needed */\n  height: 40px !important; /* Adjust the height as needed */\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.control-buttonsRed:hover {\n  background-color: #d32f2f; /* Darker red on hover */\n  transform: scale(1.1);\n}\n\n.control-buttonsRed:active {\n  background-color: #b71c1c; /* Even darker red when clicked */\n  transform: scale(0.9);\n}\n\n.control-buttonsRec {\n  background-color: #f7f7f7 !important; /* Set the background color to light grey */\n  border-radius: 20px !important; /* Make the button circular */\n  width: 70px !important; /* Adjust the width as needed */\n  height: 40px !important; /* Adjust the height as needed */\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.bottom-middle {\n  background-color: none;\n  padding: 10px 20px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 20px;\n  align-items: flex-end;\n  left: 58%;\n  z-index: 11;\n}\n\n.formattedTime {\n  color: white;\n  font-family: \"Courier New\", Courier, monospace;\n  font-size: 14px;\n  align-self: center;\n  background-color: #b3b3b3;\n  border-radius: 14px;\n  line-height: 0%;\n  padding: 2px 4px;\n}\n\n.plexar_font {\n  color: #59f !important;\n}\n.text-wrap {\n  white-space: normal !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.sub_heading {\n  color: gray;\n  font-size: 90%;\n}\n.sub_heading2 {\n  color: gray;\n  font-size: 60%;\n}\n.control-button {\n  margin: 0 10px;\n  padding: 10px;\n}\n\n.bottom-right {\n  border: 1px solid #fafbfe;\n  background-color: white;\n  padding: 10px 20px;\n  border-radius: 41px;\n  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 20px;\n  right: 100px;\n}\n\n.recording-button {\n  padding: 10px;\n}\n\n.sideNav {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ff6500;\n  border-radius: 10px;\n  background-color: #ffffff;\n  margin-right: 5px;\n}\n\n.message-screen {\n  /* display: grid;\n  grid-template-columns: 30% 69%; */\n  /* height: 90vh; */\n  border-radius: 10px;\n  padding: 16px;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n\n  /* gap: 16px; */\n}\n\n/* @media (min-width: 1024px) {\n  .message-screen {\n    display: grid;\n    grid-template-columns: 30% 69%;\n  }\n} */\n\n@media (max-width: 991.9px) {\n  .rightDiv {\n    margin-top: 16px;\n  }\n\n  .noRequests {\n    margin-top: 10px !important;\n    margin-bottom: 17px !important;\n  }\n\n  .welcome-to {\n    font-size: 32px !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .add-frn {\n    width: 80px !important;\n  }\n\n  .mng-btn {\n    width: 120px !important;\n  }\n\n  .msg-name {\n    display: none !important;\n  }\n}\n\n@media (min-width: 767.9px) {\n  .message-screen {\n    height: 90vh;\n  }\n\n  .chat-header {\n    height: 60px;\n  }\n}\n\n@media (max-width: 767.9px) {\n  .avt-sec {\n    padding-left: 16px !important;\n  }\n\n  .chat-header {\n    height: 60px;\n  }\n\n  .chatheader-info {\n    display: none !important;\n  }\n\n  .message-input {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    background: white;\n    .colorIcon2 {\n      svg {\n        height: 35px !important;\n        width: 35px !important;\n      }\n    }\n\n    input {\n      padding-right: 0 !important;\n    }\n\n    .msg-type-area {\n      padding: 0 !important;\n      margin-right: 5px !important;\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .message-input-icons {\n      right: 70px !important;\n    }\n\n    .message-input-icons :first-child {\n      padding-right: 0 !important;\n    }\n\n    .message-input-icons :last-child {\n      padding-left: 0 !important;\n    }\n  }\n}\n\n.buzzcomScreen {\n  overflow-y: auto;\n}\n.buzzcomScreen::-webkit-scrollbar {\n  display: none;\n}\n\n.message-screen::-webkit-scrollbar {\n  display: none; /* Hides the scrollbar in WebKit browsers */\n}\n\n.message-sidebar {\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.message-sidebar::-webkit-scrollbar {\n  display: none; /* Hides the scrollbar in WebKit browsers */\n}\n\n.message {\n  cursor: pointer;\n  padding: 10px;\n  align-items: center;\n}\n\n.messageEnd {\n  display: flex;\n  cursor: pointer;\n  padding: 10px;\n\n  align-items: center;\n}\n.selected {\n  background-color: #eff4f7 !important; /* Highlight selected chat */\n  height: auto !important;\n  width: auto !important;\n}\n.color {\n  color: red;\n}\n.message img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.message-info {\n  text-align: left;\n  margin-left: 10px;\n  line-height: 4px;\n  font-weight: 500;\n  font-family: \"Roboto\", sans-serif;\n  flex: 1;\n  padding-top: 12px;\n  font-size: 20px;\n  color: #6c757d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-grow: 1;\n}\n\n.chatHeader {\n  width: 964px;\n  height: 60px;\n  background-color: #ff6500;\n}\n\n.chatheader-info {\n  color: white;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18.75px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2;\n}\n/* CSS for status indicators */\n.status-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-left: 5px;\n}\n\n.online {\n  background: green;\n}\n\n.offline {\n  background: grey;\n}\n\n.away {\n  background: yellow;\n}\n\n.chat-sidebar {\n  /* display: flex; */\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background-color: #f5f5f5;\n  min-height: 100%;\n}\n.borders ::-webkit-scrollbar-thumb {\n  background-color: grey !important;\n}\n\n.borders .css-78trlr-MuiButtonBase-root-MuiIconButton-root {\n  border-radius: 0px !important;\n  /* position: static !important;; */\n}\n.borders .css-8je8zh-MuiTouchRipple-root {\n  border-right: 0px !important;\n}\n\n.dropdown-menu {\n  width: 5px;\n  overflow: hidden;\n}\n\n.iconColor {\n  color: white !important;\n}\n.chatText {\n  border: 1px solid #ccc;\n  width: 100%;\n  background-color: white;\n}\n\n.chat-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-radius: 10px 10px 0 0;\n  background-color: #ff6500;\n  padding: 0px 12px;\n  padding-left: 20px;\n}\n\n.message-list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow: \"hidden\";\n  /* margin-top: 10px; */\n  display: flex;\n  flex-direction: column;\n  border: none;\n  padding-top: 15px;\n}\n\n.message-input {\n  flex: 0 0 auto;\n  display: \"flex\";\n  align-items: \"center\";\n}\n.bg-warning {\n  background-color: #ffc107 !important;\n}\n\n.bg-danger {\n  background-color: #dc3545 !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\nimg.rounded-circle {\n  object-fit: cover;\n}\n\n.message {\n  padding: 5px;\n\n  /* max-width: 70%; */\n}\n.micClr .css-i4bv87-MuiSvgIcon-root {\n  color: #f85252 !important;\n}\n.closeIc {\n  position: absolute;\n  right: 9%;\n}\n.wide {\n  background: rgb(247, 247, 247);\n  border-radius: 10px;\n  padding: 10px;\n  margin: 15px;\n  flex: 1 1 0%;\n}\n\n.subHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-block: 10px;\n  /* margin: 1px; */\n  border-bottom: 1px solid #dfdfdf;\n}\n\n.Header1 {\n  margin-left: 8px;\n}\n\n.layout-contact-messages {\n  /* display: grid;\n  grid-template-columns: 4% 95%; */\n  margin-top: 95px;\n}\n\n.buzzSideNavItem {\n  width: 100%;\n  height: 30px;\n  border: none;\n  justify-content: center;\n  align-items: center;\n}\n\n.leftDiv {\n  border: 1px solid #dcdcdc;\n  border-radius: 10px;\n  color: #d0d0d0;\n  margin-bottom: 0px;\n  font-size: 10px; /* Adjust the margin as needed */\n  height: 100%;\n  overflow: hidden;\n\n  /* overflow-x: hidden; */\n}\n\n.leftDiv::-webkit-scrollbar {\n  display: none; /* Hides the scrollbar in WebKit browsers */\n}\n\n.rightDiv {\n  border: 1px solid #dcdcdc;\n  border-radius: 10px;\n  margin-bottom: 0px;\n  font-size: 10px; /* Adjust the margin as needed */\n  overflow-y: auto;\n  overflow: hidden;\n  height: 100%;\n}\n.css-106c1u2-MuiBadge-badge {\n  background-color: #5599ff !important;\n}\n.message-time {\n  position: relative;\n  top: -35px;\n  text-align: left;\n  margin-bottom: 0px;\n  margin-left: 15px;\n  color: #d0d0d0;\n  font-size: 10px; /* Adjust the mcustomargin as needed */\n}\n.custom-message-time {\n  position: relative;\n  top: 10px;\n  text-align: right;\n  margin-bottom: 0px;\n  margin-right: 30px;\n  color: #d0d0d0;\n  font-size: 10px; /* Adjust the margin as needed */\n}\n\n.custom-outgoing-message {\n  display: flex;\n  justify-content: flex-end; /* Push the messages to the right side */\n  color: white !important;\n}\n.EmojiPickerReact {\n  position: absolute !important;\n  top: -460px;\n  right: -50px;\n}\n.custom-message-text p,\n.message-text p {\n  top: 4px !important;\n  position: relative;\n}\n\n.custom-message-text {\n  line-height: 10px !important;\n\n  padding: 8px;\n  margin-top: 10px;\n  font-size: 14px;\n  border-radius: 8px;\n  background-color: #ff6500; /* Background color for outgoing messages */\n  margin-left: 10px; /* Adjust the margin between the time and the message */\n}\n\n.message-text {\n  padding: 8px;\n  border-radius: 8px;\n  font-size: 14px;\n  display: inline-block;\n  background-color: #f2f2f2; /* Match the background color of incoming messages */\n}\n\n.incoming1 {\n  align-self: flex-start;\n}\n.message1 {\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  /* max-width: 70%; */\n}\n\n.incoming {\n  /* background-color: #e0e0e0; */\n  position: relative;\n  top: -45px;\n  align-self: flex-start;\n}\n\n.outgoing {\n  /* background-color: #007bff; */\n  color: #fff;\n  align-self: flex-end;\n}\n\n.username {\n  font-weight: bold;\n}\n\n.fixed-header {\n  background-color: #5599ff !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n  z-index: 111;\n}\n\n.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked,\n.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate {\n  color: #f5bf00 !important;\n}\n.incDiv {\n  height: 58px !important;\n  border: 1px solid #dcdcdc !important;\n  border-radius: 5px !important;\n}\n.incrementButton {\n  padding: 0px 5px !important;\n  min-width: 16px !important;\n  height: 20px !important;\n  border-radius: 15px !important;\n  color: #dcdcdc !important;\n  border: 2px solid #dcdcdc !important;\n  font-weight: 700 !important;\n  margin: 0px 10px !important;\n}\n.css-1ps6pg7-MuiPaper-root {\n  box-shadow: none !important;\n}\n.decrementButton {\n  margin: 0px 10px !important;\n  padding: 0px 5px !important;\n  min-width: 16px !important;\n  height: 20px !important;\n  border-radius: 5px !important;\n  color: #dcdcdc !important;\n  border: 2px solid #dcdcdc !important;\n  font-weight: 700 !important;\n}\n\n.chipMain {\n  height: 45px !important;\n  padding-left: 10px !important;\n  border-radius: 10px !important;\n}\n.chipMain1 {\n  height: 45px !important;\n  padding-left: 10px !important;\n  border-radius: 10px !important;\n  border: 1px solid #f5bf00 !important;\n}\n.chipMainDelete1 {\n  color: #f5bf00 !important;\n  font-size: 16px !important;\n  border: 1px solid;\n  border-radius: 5px;\n  top: -9px;\n  position: relative;\n  right: -2px;\n}\n.chipMainDelete {\n  color: #f5bf00 !important;\n  font-size: 16px !important;\n  border: 1px solid;\n  border-radius: 5px;\n  top: -9px;\n  position: relative;\n  right: -7px;\n}\n.MuiChip-label {\n  color: #8a8a8a;\n}\n.chipMain {\n  background-color: #f9faff !important;\n}\n.chipMain1 {\n  background-color: white !important;\n}\n.MuiDrawer-paper {\n  border-right: 1px solid #f5bf00 !important;\n  border-top: 1px solid #f5bf00 !important;\n  border-top-right-radius: 10px !important;\n}\n.MuiButtonBase-root {\n  box-shadow: none !important;\n}\n.subheader {\n  /* background-color: white !important; */\n  margin-top: 40px !important;\n  height: 40px;\n  border-bottom: 1px solid #e4e4e4 !important;\n}\n\n.logo {\n  width: 33px;\n  height: 33px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n}\n.MuiSelect-outlined {\n  text-align: left;\n  padding-left: 5% !important;\n  padding-top: 9% !important;\n}\n.icon-button {\n  margin-right: 10px;\n}\n.icon-button svg {\n  /* margin-right: 10px; */\n  width: 16px;\n  height: 16px;\n}\n\n.icon {\n  width: 33px;\n  height: 33px;\n}\n\n.expert-icon {\n  width: 26px;\n  height: 26px;\n}\n\n.admin-text {\n  display: flex;\n  margin-right: 10px;\n  font-size: 10px;\n}\n\n.sub-text {\n  font-size: 12px; /* Adjust the font size as needed */\n  margin: 0;\n  font-weight: 500;\n}\n\n.profile-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.vertical-divider {\n  width: 2px;\n  height: 20px; /* Adjust the height as needed */\n  background: #e0e0e0; /* Vertical divider color */\n  /* margin-right: 10px;  */\n  align-items: center;\n  top: 8;\n}\n\n.profile-image {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%; /* Make it round */\n}\n.MuiFormControl-root,\n.MuiOutlinedInput-root {\n  background: white !important;\n  height: 50px !important;\n}\n.horizontal-list {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0 !important;\n}\n\n/* Style for each list item */\n.horizontal-list-item {\n  margin-right: 20px; /* Adjust the spacing as needed */\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n}\n.horizontal-list-item a {\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 400;\n  color: #a4a4a4;\n  margin-left: 5px;\n}\n.MuiDrawer-root,\n.MuiDrawer-paper {\n  width: 40px !important;\n}\n.horizontal-list-item .horizontal-list-icon {\n  height: 20px;\n  width: 20px;\n  color: #a4a4a4;\n}\n\n.horizontal-list-icon {\n  margin-right: 5px; /* Adjust the spacing between icon and text */\n}\n\n/* Style for active list item */\n.active {\n  color: black !important ;\n}\nsvg use {\n  fill: #ff0000; /* Change the fill color to red (#FF0000) */\n}\n.icon {\n  width: 20px;\n  height: 20px;\n  fill: #000; /* Default color */\n  transition: fill 0.3s; /* Smooth transition for color change */\n}\n\n.icon-hover:hover {\n  fill: #ff0000; /* New color on hover (e.g., red) */\n}\n\n/* Style for active icon */\n.horizontal-list-icon.active {\n  color: #f5bf00 !important; /* Change the icon color to yellow for active items */\n}\n.App {\n  font-family: sans-serif;\n}\n.uploadButton {\n  height: 25px !important;\n  border-radius: 6px !important;\n  width: 70px !important;\n  font-size: 12px !important;\n}\n.createButton {\n  height: 40px;\n  border-radius: 8px !important;\n  width: 160px;\n  font-size: 14px !important;\n}\n.listButton {\n  height: 30px !important;\n  width: 70px !important;\n  font-size: 12px !important;\n}\ntable > thead > tr > th {\n  font-size: 14px;\n  font-weight: 400;\n  color: #6b6b6b !important;\n}\ntable > tbody > tr > td {\n  vertical-align: middle !important;\n  font-size: 14px;\n  padding: 0px !important;\n  font-weight: 400;\n  color: #a4a4a4 !important;\n}\ntable > tbody > tr > td input {\n  border: none;\n  background: #f4f5fb;\n  padding: 10px;\n  width: 100%;\n}\n\n.reddit\n  .css-1m4j16o-MuiFormControl-root-MuiTextField-root\n  .MuiFilledInput-root {\n  background-color: transparent !important;\n}\n.switchPlace {\n  position: absolute !important;\n  left: 74%;\n  top: 21px;\n  z-index: 1111 !important;\n}\n.switchPlace1 {\n  position: absolute !important;\n  left: 74%;\n  top: -50px;\n  z-index: 1111 !important;\n}\n\n.css-1fqi8hc-MuiButtonBase-root-MuiListItemButton-root:hover {\n  background-color: #f5bf00 !important;\n}\n.checks {\n  text-align: left;\n}\n/* .MuiOutlinedInput-notchedOutline {\n  border-width: 1px !important;\n  border-color: #ccc;\n} */\n\n.checks .MuiTypography-root {\n  color: \"#A4A4A4\" !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #f5bf00 !important;\n}\n.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\n  color: #8a8a8a !important;\n}\n.customiseSelect {\n  position: absolute !important;\n  top: -11px !important;\n\n  font-size: 12px !important;\n}\n.drawers .MuiDrawer-paperAnchorLeft {\n  margin-top: 80px !important;\n}\n.fixed-header {\n  background-color: #333;\n  color: white;\n\n  padding-left: 5px;\n  padding-right: 25px;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n.custom-container {\n  display: flex;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 16px;\n  align-items: center;\n}\n\n.custom-image-container {\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 16px;\n  width: 80px;\n  height: 80px;\n}\n.MuiSwitch-switchBase {\n  color: #f5bf00 !important;\n}\n.error-message {\n  text-align: left;\n  font-size: 13px;\n  color: red;\n}\n.custom-image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.error .MuiInputBase-root {\n  border-color: red !important ;\n}\n.iconicMain:hover {\n  background-color: #f5bf00 !important;\n}\n.iconicMain:hover .iconic .MuiSvgIcon-root {\n  color: white !important;\n}\n.iconic .MuiSvgIcon-root {\n  height: 15px !important;\n  width: 15px !important;\n}\n.custom-text-container {\n  flex: 1;\n  text-align: left;\n}\n\n.custom-heading {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.custom-url {\n  font-size: 14px;\n  font-weight: 500;\n\n  color: #6c6c6c; /* Your primary color */\n}\n\n.custom-button {\n  margin-left: 16px;\n}\n\n.subheader {\n  background-color: #f4f4f4;\n  padding: 5px;\n  padding-right: 25px;\n  margin-top: 70px; /* Adjust this margin to make space for the fixed header */\n  width: 100%;\n  position: fixed;\n  z-index: 111;\n}\n\n#columnHeaders {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #f0f0f0;\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Styling for the draggable columns */\n.draggable-column {\n  background-color: #fff;\n  padding: 8px;\n  border-right: 1px solid #ddd;\n}\n\n/* Styling for the last column */\n.draggable-column:last-child {\n  border-right: none;\n}\n\n/* Styling for the dragged column while dragging */\n.dragging {\n  background-color: #f0f0f0;\n  transition: background-color 0.2s;\n}\n\n/* buzzcom.css */\n.layout {\n  min-height: 100vh;\n}\n\n.logo {\n  width: 100px; /* Fixed width of container */\n  height: 100px; /* Fixed height of container */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden; /* Hide overflow if the image doesn't perfectly fit */\n  background-color: #f0f0f0; /* Optional: background color to visually see the box */\n}\n\n.logo img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover; /* Fill the container without stretching */\n  object-position: center;\n}\n\n.signup-button {\n  float: right;\n}\n\n.ant-layout-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .signup-button {\n    display: none; /* Hide on smaller screens if needed */\n  }\n}\n\n.modal-backdrop,\ndiv[role=\"dialog\"],\n.toast {\n  z-index: 99999999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
